var _rect, _rect2, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCompanyAvatar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.37945,
    y: 0.37945,
    width: 39.2411,
    height: 39.2411,
    rx: 8.72735,
    fill: "#FAFAFA"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.37945,
    y: 0.37945,
    width: 39.2411,
    height: 39.2411,
    rx: 8.72735,
    stroke: "white",
    strokeWidth: 0.7589
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.0431 17.3259H29.984C30.5454 17.3259 31.0003 17.781 31.0003 18.3422V23.7536C31.0003 25.8164 29.3281 27.4887 27.2653 27.4887H27.2476C25.1848 27.489 23.5122 25.817 23.512 23.7541V17.8571C23.5119 17.7874 23.5256 17.7183 23.5523 17.6538C23.579 17.5894 23.6181 17.5308 23.6674 17.4814C23.7168 17.4321 23.7753 17.393 23.8398 17.3663C23.9043 17.3396 23.9734 17.3259 24.0431 17.3259Z",
    fill: "#5A62C3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.0584 16.256C29.3877 16.256 30.4654 15.1783 30.4654 13.849C30.4654 12.5196 29.3877 11.442 28.0584 11.442C26.729 11.442 25.6514 12.5196 25.6514 13.849C25.6514 15.1783 26.729 16.256 28.0584 16.256Z",
    fill: "#5A62C3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5697 16.2555C22.4898 16.2555 24.0464 14.6989 24.0464 12.7787C24.0464 10.8586 22.4898 9.30197 20.5697 9.30197C18.6495 9.30197 17.0929 10.8586 17.0929 12.7787C17.0929 14.6989 18.6495 16.2555 20.5697 16.2555Z",
    fill: "#7B83EB"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M25.2056 17.3259H15.3991C14.8445 17.3396 14.4058 17.7999 14.4186 18.3545V24.5265C14.3412 27.8547 16.9742 30.6166 20.3023 30.698C23.6304 30.6166 26.2634 27.8547 26.1861 24.5265V18.3545C26.1989 17.7999 25.7602 17.3396 25.2056 17.3259Z",
    fill: "#7B83EB"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M20.8372 17.3259V25.975C20.8359 26.169 20.7773 26.3583 20.6689 26.5191C20.5604 26.6799 20.4068 26.8051 20.2274 26.879C20.1106 26.9284 19.9851 26.9538 19.8583 26.9538H14.8892C14.8196 26.7773 14.7555 26.6007 14.7019 26.419C14.5147 25.8052 14.4192 25.1671 14.4185 24.5254V18.3529C14.4056 17.7992 14.8436 17.3396 15.3973 17.326L20.8372 17.3259Z",
    fill: "#01274E"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M20.3025 17.3259V26.5099C20.3025 26.6367 20.2771 26.7622 20.2277 26.879C20.1538 27.0584 20.0286 27.2119 19.8678 27.3204C19.7069 27.4289 19.5177 27.4875 19.3237 27.4887H15.141C15.0501 27.3122 14.9644 27.1357 14.8896 26.9538C14.8177 26.779 14.7552 26.6005 14.7024 26.419C14.5151 25.8052 14.4196 25.1671 14.4189 24.5254V18.3529C14.4061 17.7992 14.8441 17.3396 15.3978 17.326L20.3025 17.3259Z",
    fill: "#01274E"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M20.3026 17.3259V25.4401C20.2986 25.979 19.8627 26.4149 19.3238 26.419H14.7024C14.5151 25.8052 14.4196 25.1671 14.4189 24.5254V18.3529C14.4061 17.7992 14.8441 17.3396 15.3978 17.326L20.3026 17.3259Z",
    fill: "#01274E"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M19.7678 17.3259V25.4401C19.7636 25.979 19.3278 26.4149 18.7889 26.419H14.7024C14.5151 25.8052 14.4196 25.1671 14.4189 24.5254V18.3529C14.4061 17.7992 14.8441 17.3396 15.3978 17.326L19.7678 17.3259Z",
    fill: "#01274E"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M20.8373 14.5602V16.245C20.7463 16.2504 20.6607 16.2558 20.5698 16.2558C20.4789 16.2558 20.3932 16.2504 20.3023 16.245C20.1218 16.2331 19.9428 16.2044 19.7675 16.1595C19.2335 16.033 18.737 15.782 18.3187 15.4269C17.9003 15.0717 17.572 14.6226 17.3605 14.1163C17.2866 13.9438 17.2293 13.7647 17.1893 13.5814H19.8584C20.3981 13.5834 20.8352 14.0204 20.8373 14.5602Z",
    fill: "#01274E"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M20.3025 15.0947V16.2447C20.122 16.2327 19.9429 16.204 19.7677 16.1591C19.2337 16.0327 18.7373 15.7816 18.3189 15.4265C17.9006 15.0713 17.5722 14.6222 17.3607 14.1159H19.3237C19.8634 14.1179 20.3004 14.555 20.3025 15.0947Z",
    fill: "#01274E"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M20.3025 15.0947V16.2447C20.122 16.2327 19.9429 16.204 19.7677 16.1591C19.2337 16.0327 18.7373 15.7816 18.3189 15.4265C17.9006 15.0713 17.5722 14.6222 17.3607 14.1159H19.3237C19.8634 14.1179 20.3004 14.555 20.3025 15.0947Z",
    fill: "#01274E"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M19.7678 15.0948V16.1592C19.2338 16.0327 18.7373 15.7817 18.3189 15.4265C17.9006 15.0714 17.5722 14.6223 17.3607 14.1159H18.7889C19.3287 14.118 19.7657 14.5551 19.7678 15.0948Z",
    fill: "#01274E"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M8.98046 14.116H18.7869C19.3285 14.116 19.7675 14.555 19.7675 15.0965V24.903C19.7675 25.4445 19.3285 25.8835 18.787 25.8835H8.98046C8.43898 25.8835 8 25.4445 8 24.903V15.0965C8 14.5549 8.43898 14.116 8.98046 14.116Z",
    fill: "url(#paint0_linear_1_194)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M16.4644 17.8486H14.504V23.1868H13.2551V17.8486H11.3039V16.8131H16.4644V17.8486Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1_194",
    x1: 212.424,
    y1: -62.4908,
    x2: 980.33,
    y2: 1267.47,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A62C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#4D55BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3940AB"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompanyAvatar);
export default __webpack_public_path__ + "static/media/company-avatar.0e79cda5c863ebbc566b5e3ddc31504d.svg";
export { ForwardRef as ReactComponent };